import {Component, OnInit} from '@angular/core';
import {User} from "../../shared/model/user";
import {ActivatedRoute, Router} from "@angular/router";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {UserService} from "../../shared/services/user/user.service";
import {UserRestaurantRole} from "../../shared/model/userRestaurantRole";
import {AuthService} from "../../shared/security/auth.service";

@Component({
  selector: 'user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.css']
})
export class UserEditComponent implements OnInit {
   user:User;
  private restaurantId:string;
  private sub: any;
  private usrrstrl:UserRestaurantRole;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public modal:Modal,
    private userservice: UserService,
    private authService:AuthService,


  ) {

    }

  ngOnInit() {


    let myRoute = this.route.snapshot;
    this.restaurantId = myRoute.params['XR'];

    this.route.data
      .subscribe(
        ( data :{user:User}) =>
        {
          this.user =  data.user;
        }
      );

  }


  save(userP:Object){


    let user =JSON.parse(JSON.stringify(userP));

    // console.log(user);

    this.user.isActive = user.isActive;
    this.user.first = user.first;
    this.user.last = user.last;
    this.user.nickName = user.nickName;

    this.usrrstrl = Object.assign({});

    this.usrrstrl.userKey = this.user.$key;
    this.usrrstrl.restaurantKey = this.restaurantId;
    this.usrrstrl.role = user.role;

    this.saveUser(this.user);
    this.saveRestaurantUser(this.usrrstrl);

  }


  saveUser(theUser){


    // console.log(theUser);

    const uesrSave$ = this.userservice.saveUser(theUser);
    uesrSave$
      .subscribe(()=>{
        let route = '/restaurants/'+this.restaurantId;
        // console.log('Navigating to '+route);
        this.router.navigate([route])
      }, err => this.messageIt('Error Editing a User',err))


  }

  saveRestaurantUser (theuserrest){

    const userServ$ = this.userservice.saveRestUser(theuserrest);
    userServ$
      .subscribe(()=>{
      }, err => this.messageIt('Error Editing a User',err))

  }




  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  cancel(){

    this.router.navigate(['/restaurants/'+this.restaurantId])
  }



  deleteEvent(){
    if (!this.user.sysUid){this.user.sysUid = null};
    let deleteUser ={
      user: {
              "deleteedDateTime": new Date().toISOString(),
              "deletedBy":this.authService.getUid(),
              "first":this.user.first,
              "last":this.user.last,
              "email":this.user.email,
              "sysUserId":this.user.sysUid,
              "userKey":this.user.$key,
              "nickName":this.user.nickName,
              "restaurantId":this.restaurantId
            }
    };
    const deleteUsers$ = this.userservice.createDeleteLog(deleteUser);
    deleteUsers$
      .subscribe(()=>{
        this.userservice.deleteUser(this.user, this.restaurantId)
          .subscribe(()=>{
            this.router.navigate(['/restaurants/'+this.restaurantId])
          }, err => this.messageIt('Error Deleting a User',err))

      }, err => this.messageIt('Error Deleting a User',err))

  }


  _cleanup(){
  }


  delete(){

    this.modal.confirm()
      .size('lg')
      .showClose(true)
      .title('Deleting User '+this.user.first+' '+this.user.last)
      .body('Please OK to Delete this user?')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => { return dialog.result })
      .then((result: any) => { this.deleteEvent() })
      .catch((err: any) => this._cleanup());

  }




}



// WEBPACK FOOTER //
// ./src/app/user/user-edit/user-edit.component.ts